export default __webpack_public_path__ + "static/media/loading-icon.da2bea71.svg";